import { useI18n } from '@/i18n/i18n'
import { LOCALES } from '@/i18n/messages'

/** The two languages side by side, for pages without the account menu. */
export function LanguageSwitch() {
  const { locale, setLocale } = useI18n()
  return (
    <div className="flex gap-1 text-[12.5px]">
      {LOCALES.map((l) => (
        <button
          key={l.id}
          type="button"
          lang={l.id}
          aria-pressed={locale === l.id}
          onClick={() => {
            setLocale(l.id)
          }}
          className={
            locale === l.id
              ? 'rounded-md px-2 py-1 font-medium text-ink'
              : 'rounded-md px-2 py-1 text-muted hover:text-ink'
          }
        >
          {l.label}
        </button>
      ))}
    </div>
  )
}
